import Button from 'src/components/ui/Button';

/**
 * Fallback UI rendered by the app-level PostHogErrorBoundary (see
 * `src/app/index.tsx`) when a rendering error escapes a component tree.
 * PostHog has already captured the exception by the time this renders.
 */
const AppErrorFallback = () => {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center">
      <h1 className="text-lg font-medium text-content-default">Something went wrong</h1>
      <p className="text-sm text-content-subtle">Please try again later. If the problem persists, contact support.</p>
      <Button variant="primary" onClick={() => window.location.reload()}>
        Reload page
      </Button>
    </div>
  );
};

export default AppErrorFallback;
